import {
  SlCard
} from "./chunk.LJF3QW2H.js";

// src/components/card/card.ts
var card_default = SlCard;
SlCard.define("sl-card");

export {
  card_default
};
